export const CLOCK_MODAL_TIMEZONE = 'America/Halifax';
export const CLOCK_PIN_MIN_LENGTH = 4;
export const CLOCK_PIN_MAX_LENGTH = 6;
export const CLOCK_PIN_SLOT_COUNT = 6;
export function sanitizeClockPin(value) {
    return value.replace(/\D/g, '').slice(0, CLOCK_PIN_MAX_LENGTH);
}
export function isClockPinSubmittable(pin) {
    return /^\d{4,6}$/.test(pin);
}
export function getClockPinSlots(pin, slotCount = CLOCK_PIN_SLOT_COUNT) {
    return Array.from({ length: slotCount }, (_, index) => index < pin.length);
}
export function getClockModalErrorMessage(error, fallback) {
    return error instanceof Error && error.message ? error.message : fallback;
}
export function formatClockTime(iso) {
    return new Date(iso).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: CLOCK_MODAL_TIMEZONE,
    });
}
export function formatClockDuration(startIso, endIso) {
    const mins = Math.round((new Date(endIso).getTime() - new Date(startIso).getTime()) / 60000);
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${h}h ${m}m`;
}
